export default __webpack_public_path__ + "static/media/IMG_20211220_213510.94162dc4.png";